// extracted by mini-css-extract-plugin
export default {"container":"Home_container__JEvo0","gridContainer":"Home_gridContainer__+QSj1","aerial":"Home_aerial__hRpZD"};